export const environments = {
  production: false,
  baseUrl: 'https://agentsupport.trigma.in/api/',
  secondaryUrl: 'https://agentsupport-api.trigma.in/',
  ngRok: 'wss://agentsupport-api.trigma.in/ws',
  checkSessionApi: 'https://auth-agentsupport.trigma.in/api/session',
  loginPortalUrl: '',
  sghAuth: {
    clientId: 'angular-client',
    issuer: 'https://auth-agentsupport.trigma.in',
    redirectUri: 'https://agentsupport-front.trigma.in/auth/callback',
    postLogoutRedirectUri: 'https://agentsupport-front.trigma.in/',
    pkce: true,
  },
};
